import type { CompileResult, ComputeResult, OhlcBar } from "../runtime-types";
import {
  compileIndicatorOnHost,
  computeIndicatorOnHost,
  ensureIndicatorRuntimeHost,
  loadCompiledOnHost,
  preloadIndicatorRuntimeHost,
} from "./indicator-runtime-host";

export async function ensureIndicatorRuntime(): Promise<void> {
  return ensureIndicatorRuntimeHost();
}

export async function compileIndicatorProject(args: {
  projectId: string;
  csprojXml: string;
  files: Record<string, string>;
}): Promise<CompileResult> {
  return compileIndicatorOnHost(args);
}

export async function loadCompiledProject(args: {
  projectId: string;
  assemblyBase64: string;
  csprojXml: string;
}): Promise<CompileResult> {
  return loadCompiledOnHost(args);
}

export async function computeIndicator(args: {
  projectId: string;
  instanceId: string;
  inputValues: Record<string, number | string | boolean>;
  bars: OhlcBar[];
  lifecycle: "init" | "calculate" | "deinit";
  mode?: "full" | "incremental";
  startIndex?: number;
}): Promise<ComputeResult> {
  return computeIndicatorOnHost(args);
}

/** Warm up runtime in background on the main thread. */
export function preloadIndicatorRuntime(): void {
  preloadIndicatorRuntimeHost();
}
